module.exports = __webpack_public_path__ + "img/Finish.c961f490.svg";